module.exports = __webpack_public_path__ + "05_glasses_black.e92a3665.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/kanai/male/layer4/05_glasses_black.png
// module id = rg2S
// module chunks = 0